import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ButtonMenu } from ".";
import { BriefCase, CardCredit, CreditCardFace, Laugh } from "../icons";
import { Col, Row } from "react-bootstrap";

const SolutionDailyBadgeWrapper = styled.div`
  height: max-content;
  padding: 0 16px;
  margin-top: 32px;
  margin-bottom: 50.5px;

  @media (max-width: 576px) {
    margin-top: 20px;
    margin-bottom: 56.72px;
  }
`;

const Header = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 12px;
  color: #776E64;
  
  .icon{
    width: 16px;
    height: 16px;
  }

  .title{
    margin-left: 6px;
  }
`;

const Content = styled.div`
  .row{
    padding: 0;
  }

  @media (max-width: 576px) {
    font-size: 0.8em;
  }
`;

const SolutionDailyBadge = () => {
  const { t } = useTranslation();

  const movePage = (path) => {
    window.open(path);
  };

  const routingPage = (path) =>{
    window.location.href = path;
  }
  return (
    <SolutionDailyBadgeWrapper>
      <Header>
        <div className="col-8 d-flex justify-content-start align-items-stretch">
          <Laugh fill="#85714d" className="icon"/>
          <div className="title color-brown">{t("your_daily_solution")}</div>
        </div>
      </Header>
      <Content className="row m-1 position-relative">
        <Row>
          <Col xs="4" onClick={() => routingPage("/business-solution/umkm")}>
            <ButtonMenu label={t("umkm")} icon={CreditCardFace} />
          </Col>
          <Col xs="4" onClick={() => routingPage("/debit-card")}>
            <ButtonMenu label={t("kartu_debit")} icon={CardCredit} />
          </Col>
          <Col xs="4" onClick={() => routingPage("/credit-card")}>
            <ButtonMenu label={t("kartu_kredit")} icon={CardCredit} />
          </Col>
          <Col xs="4" onClick={() => routingPage("/bukopin-priority")}>
            <ButtonMenu label={t("bukopin_prioritas")} icon={BriefCase} />
          </Col>
        </Row>
      </Content>
    </SolutionDailyBadgeWrapper>
  );
};

export default SolutionDailyBadge;
